"use client";

// =============================================================================
// CARD SCRIM
// =============================================================================
// Radial gradient overlay at bottom of viewport for text readability
// Used by both OrbCard (projects) and ContactCard (contact moons)

interface CardScrimProps {
  scrimColor: string; // RGB triplet from getScrimColor()
  hasEntered: boolean;
  animation?: string; // CSS animation string for initial fade-in
  peekProgress?: number; // 0 = full idle scrim, 1 = full peek scrim (OrbCard only)
  idleScrimHeight?: number; // Default 380 (OrbCard) or 280 (ContactCard)
}

export function CardScrim({
  scrimColor,
  hasEntered,
  animation,
  peekProgress = 0,
  idleScrimHeight = 380,
}: CardScrimProps) {
  return (
    <>
      {/* Idle scrim - radial gradient from bottom, fades out during peek */}
      <div
        className="fixed z-[11] pointer-events-none"
        style={{
          bottom: 0,
          left: 0,
          right: 0,
          height: idleScrimHeight,
          background: `radial-gradient(ellipse 120% 100% at 50% 100%, rgba(${scrimColor},0.85) 0%, rgba(${scrimColor},0.4) 40%, rgba(${scrimColor},0) 70%)`,
          opacity: (1 - peekProgress) * (hasEntered ? 1 : 0),
          animation,
          transition: hasEntered ? "opacity 0.2s ease" : undefined,
        }}
      />

      {/* Peek scrim - linear gradient that fades IN during peek (OrbCard only) */}
      {peekProgress > 0 && (
        <div
          className="fixed z-[12] pointer-events-none"
          style={{
            bottom: 0,
            left: 0,
            right: 0,
            height: "70vh",
            background: `linear-gradient(to top, rgba(${scrimColor},1) 0%, rgba(${scrimColor},1) 50%, rgba(${scrimColor},0.9) 70%, rgba(${scrimColor},0) 100%)`,
            opacity: peekProgress * (hasEntered ? 1 : 0),
            transition: hasEntered ? "opacity 0.3s ease" : undefined,
          }}
        />
      )}
    </>
  );
}
